import { render, staticRenderFns } from "./AddEquipos.vue?vue&type=template&id=2f9bfccf&scoped=true&"
import script from "./AddEquipos.vue?vue&type=script&lang=ts&"
export * from "./AddEquipos.vue?vue&type=script&lang=ts&"
import style0 from "./AddEquipos.vue?vue&type=style&index=0&id=2f9bfccf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9bfccf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2f9bfccf', component.options)
    } else {
      api.reload('2f9bfccf', component.options)
    }
    module.hot.accept("./AddEquipos.vue?vue&type=template&id=2f9bfccf&scoped=true&", function () {
      api.rerender('2f9bfccf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/AddEquipos.vue"
export default component.exports